module.exports = __webpack_public_path__ + "img/tablet_b.393c4fb5.svg";